import { AgentCommon } from '~/agents/common/common/agent'

export const ExecutiveAssistantAgentCommon: AgentCommon = {
  key: 'executiveAssistantV2',
  hasOnboarding: true,
  hasSettings: true,
  guidelines: [
    {
      label: 'Any specific rules to help me categorize your emails better?',
      tag: 'email_labeling_rules',
      suggestions: [
        'Label emails from clients as "Client".',
        'Mark newsletters as "Newsletter".',
        'Label anything from my accountant as "Finance".',
        'Apply "Urgent" to emails containing words like "ASAP", "immediately", or "urgent".',
        'Use the label "Legal" for messages from legal@ or with attachments containing contracts.',
        'Mark calendar invitations with the "Meetings" label.',
        'Apply "Personal" to emails from known friends or family.',
        'Do not label any email that is auto-generated or from noreply addresses.',
        'Use "Follow-Up" for any email I have not responded to in 48 hours.',
        "Apply labels exactly as I've named them in my email account settings.",
      ],
    },
    {
      label: 'How should I write emails?',
      tag: 'email_drafting_style',
      suggestions: [
        'Use a professional and courteous tone',
        'Start with a clear subject line',
        'Keep the email concise and to the point',
        'Use formal greetings like "Dear [Name]"',
        'Summarize key points in the opening paragraph',
        'Use bullet points for multiple items or tasks',
        'Include a clear call-to-action if needed',
        'Always close politely with "Best regards" or "Sincerely"',
        'Avoid slang, emojis, or overly casual phrases',
        'Double-check names, titles, and company names',
        'Use proper grammar and spelling throughout',
        'Keep sentences short and active',
        'Avoid unnecessary jargon',
        'Make sure any requested actions have a deadline if needed',
        'Maintain confidentiality when needed',
        'Proofread before sending',
        'Summarize meeting times clearly if suggesting one',
        'Use templates when appropriate but personalize slightly',
        'Clarify next steps at the end of the email',
        'Maintain a friendly but efficient tone',
      ],
    },
    {
      label: 'Which emails should I draft a reply to, and which should I not?',
      tag: 'email_reply_conditions',
      suggestions: [
        'Do not reply to cold emails.',
        'Never auto-reply to emails with attachments.',
        'Only draft replies for known contacts.',
        'Skip replies to emails that contain the word "unsubscribe".',
        'Ask me before replying to anything flagged as sensitive.',
      ],
    },
    {
      label: 'What types of emails should I archive?',
      tag: 'email_auto_archive_rules',
      suggestions: [
        'Do not archive emails from the legal team.',
        'Auto-archive newsletters after 3 days.',
        `Archive internal daily reports after I have read them.`,
        'Never archive emails that are marked as "Needs Reply".',
        'Automatically archive read emails from noreply addresses.',
      ],
    },
    {
      label: 'What are your preferences for scheduling meetings?',
      tag: 'meeting_scheduling_preferences',
      suggestions: [
        'Do not schedule anything past 5pm.',
        'Prefer 45-minute meetings.',
        'Leave a 15-minute buffer between meetings.',
        'Only schedule meetings between 10am and 4pm on weekdays.',
        'Use Google Meet by default, unless the sender requests Zoom.',
      ],
    },
  ],

  rulesCleaning: {
    deleteAll: [
      {
        key: { not: 'main' },
      },
    ],
  },
}
